import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';
import { SCHEDULING_COLOR_OPTIONS } from '../../scheduling/schedulingConstants';

// Rename the name of the function:
const OtherActivitiesForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    const apiObject = 'timetype'

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        {
            name: 'name',
            label: 'scheduling.other_activities_types.name_label',
            type: 'text',
            placeholder: 'scheduling.other_activities_types.name_placeholder',
        },
        { 
            type: 'dropdown', 
            name: 'type', 
            label: 'scheduling.other_activities_types.type_label', 
            disabled_selected: 'forms.select_type_disabled_selected',
            allowNoneOption: false,
            showSearch: false,
            hardcodedOptions: [
                { value: 'internal', name: 'timetype.type.internal'},
                { value: 'leave', name: 'timetype.type.leave'},
                { value: 'sickness', name: 'timetype.type.sickness'},
            ],
        },
        {
            name: 'is_calculated_leave',
            dependentOn: { fieldName: 'type', value: 'leave' },
            label: 'scheduling.other_activities_types.is_calculated_leave_label',
            tooltipText: 'scheduling.other_activities_types.is_calculated_leave_tooltip',
            type: 'checkbox',
        },
        {
            name: 'color',
            label: 'scheduling.other_activities_types.color_label',
            type: 'tabs',
            showIconOnly: true,
            customClass: 'label',
            options: SCHEDULING_COLOR_OPTIONS,
        },
        {
            name: 'is_active',
            label: 'scheduling.other_activities_types.active_label',
            type: 'checkbox',
            showOnEdit: true,
        }
    ];

    return (
        <FormModal 
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
        />
    );
};

export default OtherActivitiesForm;